import jsvat from "jsvat";

export const formatVat = value => {
	const vatResult = jsvat.checkVAT(value);
	if (!vatResult.isValid) {
		const beVatResult = jsvat.checkVAT(`BE${value}`);
		if (beVatResult.isValid === true) {
			return beVatResult.value;
		}
	}
	return vatResult.value;
};

const validator = value => {
	const formattedValue = formatVat(value);
	const vatResult = jsvat.checkVAT(formattedValue);
	return vatResult.isValid;
};

export default validator;
